// extracted by mini-css-extract-plugin
export default {"controls":"Controls_controls__VIBAC","dpad":"Controls_dpad__GFvCD","actions":"Controls_actions__BSmVB"};